import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { onScreen } from 'Lib/on-screen/on-screen';
import { speed } from 'Lib/speed/speed';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import 'Vendor/owlcarousel/owl.carousel.min';

const $parent = $('.content-slider');
const $slider = $parent.find('.content-slider__slider');
const cSliderOn = 'owl-carousel';
let lastStateIsMobileScreen = isMobileScreen();

function isMobileScreen() {
    return (getW() < eksmoBP.smMin);
}

function loadPicsOnSlider() {
    onScreen($('.content-slider__item-pic'), loadSrcOrBg);
}

function setSliders() {
    if (isMobileScreen()) {
        $slider.trigger('destroy.owl.carousel');
        loadPicsOnSlider();
    } else {
        $slider.each(function () {
            $(this).trigger('destroy.owl.carousel')
                .removeClass(cSliderOn)
                .addClass(cSliderOn)
                .owlCarousel({
                    smartSpeed: speed * 2,
                    dots: true,
                    nav: true,
                    items: 1,
                    slideBy: 1,
                    margin: 0,
                    dotsContainer: '.content-slider__dots',
                    dotsClass: ['dots'],
                    dotClass: ['dots__item'],
                    navClass: ['content-slider__arrow-prev arrow arrow_shadow arrow_prev', 'content-slider__arrow-next arrow arrow_shadow arrow_next'],
                    navText: ['', ''],
                    onInitialized: loadPicsOnSlider,
                    mouseDrag: false,
                });
        });
    }
}

setSliders();

$('body').on('eksmoResizeWidth', () => {
    if (isMobileScreen() !== lastStateIsMobileScreen) {
        setSliders();
        lastStateIsMobileScreen = isMobileScreen();
    }
});